import { FlexDiv } from 'components/generic/HomePageComponents'

const ProfileCardsContainer = (props) => (
  <FlexDiv
    display='flex'
    justifyContent={{ _: 'center', tablet: 'space-between' }}
    flexDirection={{ _: 'column', desktop: 'row' }}
    {...props}
  />
)

export default ProfileCardsContainer
